import { useSelector } from 'react-redux';

const useGetOrderId = () => {
    return useSelector((state) => state.order_id.order_id);
};

export default useGetOrderId;